<mat-dialog-content>


  <div class="flex">
    <div class="data" style="text-align: center;">
      <H4>
        <mat-icon class="icon-size-large" color="accent">help_center</mat-icon>
      </H4>
      @for (message of data.messages; track message) {
      <h5 style="margin-top: -5px" class="color-contrast-theme">{{message |translate}}</h5>
      }

    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="accent" [mat-dialog-close]="true">
    <mat-icon>check</mat-icon>
  </button>
  <button mat-flat-button color="primary" [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>
</mat-dialog-actions>